import _ from "lodash";

export default {
    methods: {
        getNamespace() {
            if( _.isString(this.namespace) ) {
                return this.namespace + '/';
            }
            return '';
        },

        nsStoreDispatch(action, playload = null) {
            return this.$store.dispatch(this.getNamespace() + action, playload);
        },

        nsStoreGetter(getter) {
            return this.$store.getters[this.getNamespace() + getter];
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/mixins/storeMixin.js